import React from "react";
import { Box, Button } from "@mui/material";
import DashboardCustomizeRoundedIcon from "@mui/icons-material/DashboardCustomizeRounded";
import { useNavigate } from "react-router-dom";
import { isDarkMode } from "../../utils/constants";
import {
  CHAT_WORKSPACE_PATH,
  primaryAppPath,
} from "../../utils/appNavigation";
import { trackFrontendEvent } from "../../utils/tracking";

const ClassicWorkspaceSidebarButton = ({ onBeforeNavigate = null }) => {
  const navigate = useNavigate();
  if (primaryAppPath() !== CHAT_WORKSPACE_PATH) return null;

  const handleOpenWorkspace = () => {
    trackFrontendEvent("workspace_default_opened_from_classic", {
      source_surface: "classic_chat_sidebar",
    });
    onBeforeNavigate?.();
    navigate(CHAT_WORKSPACE_PATH);
  };

  return (
    <Box sx={{ px: 2, mt: 1, mb: 1 }}>
      <Button
        data-classic-workspace-sidebar-button
        fullWidth
        variant="outlined"
        onClick={handleOpenWorkspace}
        startIcon={<DashboardCustomizeRoundedIcon sx={{ fontSize: 19 }} />}
        sx={{
          minHeight: 48,
          justifyContent: "flex-start",
          gap: 0.5,
          px: 1.25,
          borderRadius: 2,
          borderColor: isDarkMode
            ? "rgba(147, 197, 253, 0.34)"
            : "rgba(37, 99, 235, 0.28)",
          color: isDarkMode ? "#DBEAFE" : "#1D4ED8",
          backgroundColor: isDarkMode
            ? "rgba(37, 99, 235, 0.10)"
            : "rgba(219, 234, 254, 0.56)",
          textTransform: "none",
          "&:hover": {
            borderColor: isDarkMode
              ? "rgba(147, 197, 253, 0.56)"
              : "rgba(37, 99, 235, 0.48)",
            backgroundColor: isDarkMode
              ? "rgba(37, 99, 235, 0.18)"
              : "rgba(219, 234, 254, 0.90)",
          },
        }}
      >
        <Box
          component="span"
          sx={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box
            component="span"
            sx={{ display: "flex", flexDirection: "column", textAlign: "left" }}
          >
            <Box component="span" sx={{ fontSize: 13.5, fontWeight: 700 }}>
              Incite 2.0
            </Box>
            <Box component="span" sx={{ fontSize: 11.5, opacity: 0.72 }}>
              Open the new workspace
            </Box>
          </Box>
          <Box
            component="span"
            sx={{
              px: 0.75,
              py: 0.2,
              borderRadius: "999px",
              backgroundColor: isDarkMode
                ? "rgba(96, 165, 250, 0.18)"
                : "rgba(37, 99, 235, 0.12)",
              fontSize: 10,
              fontWeight: 800,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            }}
          >
            New
          </Box>
        </Box>
      </Button>
    </Box>
  );
};

export default ClassicWorkspaceSidebarButton;
